<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/SIM/SIMList')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 详情 -->
    <el-descriptions title="" border>
      <el-descriptions-item label="ICCID">{{
        info.iccid
      }}</el-descriptions-item>
      <el-descriptions-item label="卡状态">{{
        info.status
      }}</el-descriptions-item>
      <el-descriptions-item label="所属企业">{{
        info.companyName
      }}</el-descriptions-item>
      <el-descriptions-item label="MSISDN">{{
        info.msisdn
      }}</el-descriptions-item>
      <el-descriptions-item label="网络状态">{{
        info.netStatus == 1 ? "已开启" : "已关闭"
      }}</el-descriptions-item>
      <el-descriptions-item label="设备编号">{{
        info.equipmentNum
      }}</el-descriptions-item>
      <el-descriptions-item label="IMSI">{{ info.imsi }}</el-descriptions-item>
      <el-descriptions-item label="是否属于流量地">苏州市</el-descriptions-item>
      <el-descriptions-item label="套餐信息">苏州市</el-descriptions-item>
      <el-descriptions-item label="IMEI">{{ info.imei }}</el-descriptions-item>
      <el-descriptions-item label="总流量">{{
        info.voiceFlow ? info.voiceFlow : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="添加时间">{{
        info.openDate
      }}</el-descriptions-item>
      <el-descriptions-item label="运营商">{{
        info.carrier
      }}</el-descriptions-item>
      <el-descriptions-item label="已用流量">{{
        info.flow
      }}</el-descriptions-item>
      <el-descriptions-item label="到期时间">{{
        info.expiryDate
      }}</el-descriptions-item>
      <el-descriptions-item label="渠道">{{
        info.source == 1 ? "移远" : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="剩余流量">- -</el-descriptions-item>
    </el-descriptions>

    <!-- 趋势图 -->
    <div class="mgt-10 flex aic jcsb">
      <div>流量使用趋势(近30日)</div>
      <div class="color0063ea">
        <span class="mgr-20">最大值：{{ monthMax }}</span>
        <span class="mgr-20">最小值：{{ monthMin }}</span>
        <span class="mgr-20">总用量：{{ monthSum }}</span>
        <span>平均用量：{{ monthAvg }}</span>
      </div>
    </div>
    <!-- 折线 -->
    <div id="main" ref="chart"></div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import * as echarts from "echarts";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      info: {},
      flowArr: [],
      dateArr: [],
      monthAvg: 0,
      monthMax: 0,
      monthMin: 0,
      monthSum: 0,
    };
  },
  mounted() {
    this.getMonth();
    // this.getEcharts();
  },
  created() {
    this.getDetail();
    this.getMonth();
  },
  methods: {
    getMonth() {
      this.$api.sim
        .monthChartsDetail({ iccid: this.$route.query.iccid })
        .then((res) => {
          if (res.code == 200) {
            if (res.code === 200) {
              this.monthAvg = res.data.monthAvg;
              this.monthMax = res.data.monthMax;
              this.monthMin = res.data.monthMin;
              this.monthSum = res.data.monthSum;
              this.flowArr = [];
              this.dateArr = [];
              res.data.monthFlowList.forEach((v) => {
                this.flowArr.push(v.flow);
                this.dateArr.push(v.date);
              });
              this.$nextTick(() => {
                this.getEcharts();
              });
            }
          }
        });
    },
    getDetail() {
      this.$api.sim
        .simDetail({ iccid: this.$route.query.iccid })
        .then((res) => {
          if (res.code == 200) {
            this.info = res.data;
          }
        });
    },
    getEcharts() {
      this.myChart = echarts.init(document.querySelector("#main"));
      this.myChart.clear();
      this.myChart.setOption({
        title: {},
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["订单笔数（笔）", "订单金额（元）"],
          data: ["使用量"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.dateArr,

          axisLabel: {
            margin: 20,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            margin: 20,
          },
        },
        series: [
          {
            name: "使用量",
            type: "line",
            stack: "Total",
            smooth: true,
            itemStyle: {
              normal: {
                color: "blue", //改变折线点的颜色
                lineStyle: {
                  color: "blue", //改变折线颜色
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: "#c5d0e4",
            },
            data: this.flowArr,
          },
        ],
      });
      // 设置窗口改变时,图表自动缩放
      window.onresize = function() {
        this.myChart.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#main {
  // background: var(--card-bg);
  width: 100%;
  height: 400px;
  margin-top: 20px;
}
</style>
